/**
 * Props that keep the browser's own autofill dropdown off a search /
 * combobox input.
 *
 * Chrome ignores `autocomplete="off"` on any field its heuristics classify as
 * a person's name, email or address — and a "search by name, email, or phone"
 * box that lives in a form which also has address inputs (estimate, job, lead)
 * is classified exactly that way. The result is a native suggestion popup
 * painted over our own results list; it is also anchored to the viewport, so
 * it stays put while the form scrolls underneath it.
 *
 * `new-password` is the one token Chrome always honours as "never autofill
 * this", and the `data-*` attributes are the equivalent opt-outs read by
 * 1Password and LastPass. Spread onto the input, never onto a field the user
 * is meant to have autofilled.
 */
export const NO_AUTOFILL_PROPS = {
  autoComplete: 'new-password',
  'data-1p-ignore': '',
  'data-lpignore': 'true',
} as const;
